export default __webpack_public_path__ + "static/media/imageEight.50f0c8d7.png";